import { Filter as IFilter, Operator } from './types';

class Filter implements IFilter {
  operator: IFilter['operator'];
  property?: string;
  value?: IFilter['value'];
  filters?: IFilter[];

  constructor(reporting: IFilter) {
    this.property = reporting.property;
    this.operator = reporting.operator;
    this.value = reporting.value;
    this.filters = reporting.filters;
  }
}

export class FilterBuilder implements Partial<IFilter> {
  property: string;
  operator: Operator;
  value: IFilter['value'];
  filters: IFilter[];

  setProperty(property: string): FilterBuilder {
    this.property = property;
    return this;
  }

  setOperator(operator: Operator): FilterBuilder {
    this.operator = operator;
    return this;
  }

  setValue(value: IFilter['value']): FilterBuilder {
    this.value = value;
    return this;
  }

  addFilter(filter: IFilter): FilterBuilder {
    if (!this.filters) {
      this.filters = [];
    }
    this.filters.push(filter);
    return this;
  }

  addFilters(filters: IFilter[]): FilterBuilder {
    if (!this.filters) {
      this.filters = [];
    }
    this.filters.push(...filters);
    return this;
  }

  build(this: IFilter): Filter {
    return new Filter(this);
  }
}
